module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds.06b5027.jpg";